/* Rimtek — commande via WhatsApp
   Construit un message détaillé (articles, quantités, prix, coordonnées client)
   et ouvre WhatsApp. Le paiement est ensuite encaissé par Bankily. */
(function () {
  'use strict';

  var CFG = window.RimtekConfig || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Formatage monétaire (format Shopify) ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number === null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents) {
    var format = CFG.moneyFormat || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Utilitaires ---------- */
  function digits(str) { return String(str || '').replace(/\D/g, ''); }

  function openWhatsApp(message) {
    var number = digits(CFG.whatsappNumber);
    if (!number) {
      alert("Le numéro WhatsApp de la boutique n'est pas configuré.");
      return;
    }
    var url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    window.open(url, '_blank', 'noopener');
  }

  function fieldValues(scope) {
    var get = function (name) {
      var el = scope.querySelector('[data-rt-wa-field="' + name + '"]');
      return el ? el.value.trim() : '';
    };
    return { name: get('name'), phone: get('phone'), city: get('city'), address: get('address') };
  }

  function validate(scope, info) {
    var missing = [];
    if (!info.name) missing.push('name');
    if (!info.phone) missing.push('phone');
    if (!info.city) missing.push('city');
    scope.querySelectorAll('[data-rt-wa-field]').forEach(function (el) {
      el.classList.toggle('rt-invalid', missing.indexOf(el.dataset.rtWaField) !== -1);
    });
    var err = scope.querySelector('[data-rt-wa-error]');
    if (err) err.hidden = missing.length === 0;
    if (missing.length) {
      var first = scope.querySelector('.rt-invalid');
      if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }
    return missing.length === 0;
  }

  function customerBlock(info) {
    var lines = [];
    lines.push('*Client :* ' + info.name);
    lines.push('*Téléphone :* ' + info.phone);
    lines.push('*Ville :* ' + info.city);
    if (info.address) lines.push('*Adresse :* ' + info.address);
    return lines.join('\n');
  }

  function footerBlock() {
    return 'Je souhaite payer par *' + (CFG.whatsappPaymentLabel || 'Bankily') + '*.';
  }

  /* ---------- Commande depuis le panier ---------- */
  function initCartOrder() {
    document.querySelectorAll('[data-rt-wa-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-rt-wa-scope]') || document;
        var info = fieldValues(scope);
        if (!validate(scope, info)) return;

        btn.disabled = true;
        fetch(root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart.items.length) {
              alert('Votre panier est vide.');
              return;
            }
            var lines = [];
            lines.push('🛒 *Nouvelle commande — ' + (CFG.shopName || 'Rimtek') + '*');
            lines.push('');
            lines.push(customerBlock(info));
            lines.push('');
            lines.push('*Articles :*');
            cart.items.forEach(function (item, i) {
              var title = item.product_title;
              if (item.variant_title && item.variant_title !== 'Default Title') {
                title += ' — ' + item.variant_title;
              }
              lines.push((i + 1) + '. ' + title);
              lines.push('   ' + item.quantity + ' × ' + money(item.final_price) + ' = ' + money(item.final_line_price));
            });
            lines.push('');
            lines.push('*Total :* ' + money(cart.total_price));
            if (cart.note) {
              lines.push('');
              lines.push('*Note :* ' + cart.note);
            }
            lines.push('');
            lines.push(footerBlock());
            openWhatsApp(lines.join('\n'));
          })
          .catch(function () { alert('Impossible de lire le panier. Réessayez.'); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- Commande d'un seul produit (fiche produit) ---------- */
  function initProductOrder() {
    document.querySelectorAll('[data-rt-wa-product]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-rt-product]') || document;
        var qtyInput = scope.querySelector('[data-rt-qty] input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        var title = btn.dataset.rtWaProduct || '';
        var variantLabel = '';
        scope.querySelectorAll('[data-rt-option]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) variantLabel += (variantLabel ? ' / ' : '') + checked.value;
        });

        var priceEl = scope.parentElement && scope.parentElement.querySelector('[data-rt-price]');
        if (!priceEl) priceEl = document.querySelector('[data-rt-price]');
        var price = priceEl ? priceEl.textContent.trim() : '';

        var lines = [];
        lines.push('🛒 *Demande de commande — ' + (CFG.shopName || 'Rimtek') + '*');
        lines.push('');
        lines.push('*Produit :* ' + title);
        if (variantLabel) lines.push('*Option :* ' + variantLabel);
        lines.push('*Quantité :* ' + qty);
        if (price) lines.push('*Prix unitaire :* ' + price);
        if (btn.dataset.rtWaUrl) {
          lines.push('*Lien :* ' + btn.dataset.rtWaUrl);
        }
        lines.push('');
        lines.push(footerBlock());
        openWhatsApp(lines.join('\n'));
      });
    });
  }

  /* ---------- Bouton flottant ---------- */
  function initFloating() {
    document.querySelectorAll('[data-rt-wa-float]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openWhatsApp('Bonjour ' + (CFG.shopName || 'Rimtek') + ' 👋\nJ\'ai une question.');
      });
    });
  }

  function init() {
    initCartOrder();
    initProductOrder();
    initFloating();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
